export const FEATURE_SERVICE = 'feature_service';
export const MAP_SERVICE = 'map_service';
export const GIS_MAP_ADDON = 'gis';
